import { type Commands } from '../../../core/context/commands';
import { UUID } from '../../../core/context/uuid/entity';
import { AssetRelations } from './repository';
import { AssetRelation } from './entity';
import { type AssetRelationData } from './dto';

export class AssetRelationsCommands
    implements Commands<AssetRelations, AssetRelation, AssetRelationData>
{
    addAll(repo: AssetRelations, data: AssetRelationData[]): AssetRelations {
        data.forEach((assetRelationData) => {
            this.add(repo, assetRelationData);
        });
        return repo;
    }

    add(repo: AssetRelations, data: AssetRelationData): AssetRelations {
        const assetRelation = new AssetRelation({
            ...data,
        });
        repo.add(assetRelation);
        return repo;
    }

    update(repo: AssetRelations, entity: AssetRelation): AssetRelation {
        repo.update(entity);
        return entity;
    }

    remove(repo: AssetRelations, id: string): void {
        repo.remove(id);
    }

    create(
        repo: AssetRelations,
        data: Omit<AssetRelationData, 'id'>,
    ): AssetRelation {
        const uuid = new UUID();
        const assetRelation = new AssetRelation({
            id: uuid.toString(),
            ...data,
        });
        repo.add(assetRelation);
        return assetRelation;
    }

    fromJSON(
        entity: AssetRelation[],
        changeCallback: () => void,
    ): AssetRelations {
        const newAssetRelations = new AssetRelations(changeCallback);
        entity.forEach((assetRelation) => {
            newAssetRelations.add(
                new AssetRelation({
                    ...assetRelation,
                }),
            );
        });
        return newAssetRelations;
    }
}
